var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("GitInfo")]),_c('pre',[_vm._v("      "+_vm._s(_vm.info)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }